<template>
  <div class="list-group-item-wrapper" @click="click">
    <mds-list-group-item :text="displayName" :metadata-below="metadata">
    </mds-list-group-item>
  </div>
</template>

<script>
import { MdsListGroupItem } from '@mds/list-group';
import Constants from '@/js/constants.js';
import Utils from '@/js/utils.js';

export default {
  name: 'AppTermSummary',
  components: { MdsListGroupItem },
  props: {
    termObject: Object,
    searchWord: ''
  },
  mixins: [Constants, Utils],
  data() {
    return {
      displayName: '',
      metadata: []
    };
  },
  mounted() {
    this.resultMetadata();
  },
  methods: {
    resultMetadata() {
      this.displayName = `${this.termObject.name}`;

      this.metadata = [this.decamelize(this.termObject['label'])];
      if (this.termObject.hasOwnProperty('identifier')) {
        this.metadata.push(this.termObject['identifier']);
      }
      if (this.termObject.hasOwnProperty('publishDate')) {
        this.metadata.push(this.termObject['publishDate'].substring(0, 10));
      }

      if (this.termObject.hasOwnProperty('synonym')) {
        const foundSynonym = this.termObject['synonym'].find(
          item =>
            item.trim().toLowerCase() === this.searchWord.trim().toLowerCase()
        );

        if (foundSynonym)
          this.displayName = `${this.termObject.name} (${foundSynonym})`;
      }

      if (this.termObject.hasOwnProperty('translation')) {
        const foundTranslation = this.termObject['translation'].find(
          item =>
            item.split(';')[1].trim().toLowerCase() ===
            this.searchWord.trim().toLowerCase()
        );

        if (foundTranslation) {
          this.metadata.push(foundTranslation.split(';')[0]);
          this.displayName = `${this.termObject.name} (${
            foundTranslation.split(';')[1]
          })`;
        }
      }
    },
    click() {
      this.$emit('click');
    }
  }
};
</script>
